/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";

import classNames from "classnames";
import IconComponent from "../elements/icon";
const Icon = React.createFactory(IconComponent);
const { func, string, bool, any, shape, arrayOf } = PropTypes;

export default class extends React.Component {
  static displayName = "MobileSheet";

  static propTypes = {
    className: string,
    label: string,
    onBack: func,
    headerActionLabel: string, // label on upper right of sheet header
    onHeaderAction: func, // no args
    wrapContent: bool,
    backgroundColor: string,
    actions: arrayOf(
      shape({
        className: string,
        label: any,
        onClick: func,
        disabled: bool,
      })
    ),
  };

  static defaultProps = { actions: [] };

  render() {
    return (
      <div className={classNames("et--mobile-sheet", this.props.className)}>
        <div className="et--mobile-sheet--header">
          {Icon({ icon: "arrow-left", onClick: this.props.onBack })}
          <span className="et--mobile-sheet--header-label">{this.props.label}</span>
          {(() => {
            if (this.props.headerActionLabel) {
              const action_disabled = !this.props.onHeaderAction || this.props.headerActionDisabled;
              return (
                <span
                  className={classNames("et--mobile-sheet--header-action", {
                    "is-disabled": action_disabled,
                  })}
                  onClick={!action_disabled ? this.props.onHeaderAction : undefined}
                >
                  {this.props.headerActionLabel}
                </span>
              );
            }
          })()}
        </div>
        <div
          className={classNames("et--mobile-sheet--content", {
            "has-actions": this.props.actions,
            "has-wrapper": this.props.wrapContent,
          })}
          style={{
            backgroundColor: this.props.backgroundColor,
          }}
        >
          {this.props.children}
        </div>
        {this.props.actions ? (
          <div className="et--mobile-sheet--actions">
            {(() => {
              if (this.props.actions.length === 1) {
                const action = this.props.actions.length[0];

                return (
                  <div className="et--mobile-sheet--single-button-wrap">
                    <button
                      className="et--mobile-sheet--single-button"
                      disabled={action.disabled}
                      onClick={action.onClick}
                    >
                      {action.label}
                    </button>
                  </div>
                );
              } else {
                const number_class = (() => {
                  switch (this.props.actions.length) {
                    case 2:
                      return "of-two";
                    case 3:
                      return "of-three";
                    default:
                      return "";
                  }
                })();

                return this.props.actions.map(action => (
                  <button
                    className={classNames("et--mobile-sheet--split-button", number_class, action.className)}
                    key={action.label}
                    disabled={action.disabled}
                    onClick={action.onClick}
                  >
                    {action.label}
                  </button>
                ));
              }
            })()}
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}
